import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { updateEnrollment } from "../../../api/endpoints/EnrollmentEndpoints";
import { Enrollment } from "../../../models/Enrollment";

export default function useUpdateEnrollment() {
  return useMutation<
    void,
    AxiosError,
    { enrollmentId: number; status: Enrollment["status"] }
  >({
    mutationKey: ["update-enrollment"],
    mutationFn: ({ enrollmentId, status }) =>
      updateEnrollment(enrollmentId, status),
  });
}
